module.exports = __webpack_public_path__ + "static/media/snowboarding.c6633d9c.svg";